class TabPane {
	constructor(tabpane) {
		this.tabpane = tabpane;
		this.tabButtons = Array.from(tabpane.querySelectorAll('.js-tab-pane__button'));
		this.tabDropdown = tabpane.querySelector('.js-tab-pane__select');
		this.dropdownOptions = Array.from(tabpane.querySelectorAll('.js-tab-pane__select-option'));
		this.tabContentList = tabpane.querySelector('.js-tab-pane__content-list');
		this.tabContents = Array.from(tabpane.querySelectorAll('.js-tab-page'));
		this.tabRow = tabpane.querySelector('.js-tab-pane-row');

		this.currentTab = this.tabButtons[0];
		this.currentTabContent = this.tabContents[0];

		this.onScollingEnd = ::this.openInitalTab;

		this.initEvents();
		if (this.tabButtons.length) this.openInitalTab();

		if (this.tabDropdown) this.openInitalTabFromDropDown();
	}

	initEvents() {
		this.tabButtons.forEach(button => {
			button.addEventListener('click', ::this.onTabClick);
		});

		this.tabDropdown && this.tabDropdown.addEventListener('change', this.onSelectDropdown);
	}

	onTabClick(e) {
		const slug = e.currentTarget.dataset.slug;
		const tab = e.currentTarget.parentNode;
		const index = this.getTabIndex(tab, tab.parentNode.children);

		document.location.hash = slug;

		this.updateAddTabHash(slug);

		this.openTab(index);
		this.setActiveTab(e.currentTarget);
	}

	onSelectDropdown = e => {
		const slug = e.target.value;
		const index = e.target.selectedIndex;

		document.location.hash = slug;

		this.openTab(index);
	};

	updateAddTabHash(slug) {
		Array.from(document.querySelectorAll('.js-add-tab-hash')).forEach(link => {
			link.href = link.href.replace(/#.+$/, '') + `#${slug}`;
		});
	}

	getTabIndex(tab, tabs) {
		return [...tabs].indexOf(tab);
	}

	openInitalTab() {
		let index = 0;
		let activeTab = this.currentTab;
		const hash = document.location.hash.replace('#', '');
		let targetTabButton = this.tabpane.querySelector(`.js-tab-pane__button[data-slug="${hash}"]`);
		if (hash !== '' && targetTabButton) {
			index = this.getTabIndex(
				targetTabButton.parentNode,
				targetTabButton.parentNode.parentNode.children
			);
			activeTab = targetTabButton;
			this.updateAddTabHash(hash);
		} else {
			const initialActiveTab = this.tabpane.querySelector(`.js-tab-page[data-active="1"]`);
			if (initialActiveTab) {
				const slug = initialActiveTab.dataset.slug;
				targetTabButton = this.tabpane.querySelector(`.js-tab-pane__button[data-slug="${slug}"]`);

				if (targetTabButton) {
					index = this.getTabIndex(
						targetTabButton.parentNode,
						targetTabButton.parentNode.parentNode.children
					);
					activeTab = targetTabButton;
					this.updateAddTabHash(hash);
				}
			}
		}

		this.openTab(index);
		this.setActiveTab(activeTab);
	}

	openInitalTabFromDropDown() {
		let index = 0;

		const hash = document.location.hash.replace('#', '');
		const targetOption = this.tabDropdown.querySelector(
			`.js-tab-pane__select-option[value="${hash}"]`
		);

		if (hash !== '' && targetOption) {
			index = this.dropdownOptions.indexOf(targetOption);
		}

		this.openTab(index);
		this.tabDropdown.selectedIndex = index;
	}

	setActiveTab(tab) {
		this.currentTab.classList.remove('is-active');
		tab.classList.add('is-active');

		this.currentTab = tab;
	}

	openTab(index) {
		const tabContent = this.tabContents[index];
		const tabIsActive = tabContent.classList.contains('is-active');
		if (tabIsActive) return;

		this.currentTabContent.classList.remove('is-active');
		tabContent.classList.add('is-active');

		this.currentTabContent = tabContent;
	}
}

const tabpanes = Array.from(document.querySelectorAll('.js-tab-pane'));

tabpanes.forEach(tabpane => {
	new TabPane(tabpane);
});
